import { render } from "./ThreePClaimRequests.vue?vue&type=template&id=1ff80ea4"
import script from "./ThreePClaimRequests.vue?vue&type=script&lang=js"
export * from "./ThreePClaimRequests.vue?vue&type=script&lang=js"

import "./ThreePClaimRequests.vue?vue&type=style&index=0&id=1ff80ea4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__